// src/api/registrosApi.js
import { api } from '../lib/api';

export const registrosApi = {
  // Configuración
  getConfiguracion: () => api.get('/configuracion'),

  // Registros
  getRegistros: (soloHoy) => api.get(soloHoy ? '/registros/hoy' : '/registros'),
  createRegistro: (data) => api.post('/registros', data),
  annularRegistro: (id, autorizacionPin) =>
    api.patch(`/registros/${id}/anular`, { autorizacionPin }),
  printRegistro: (id) => api.post(`/registros/${id}/print`),

  // Usuarios
  getUsuarios: () => api.get('/usuarios'),
  getUsuario: (id) => api.get(`/usuarios/${id}`),
  verifyPassword: (data) => api.post('/usuarios/verificar-password', data),
  verifyAuthorization: (data) => api.post('/usuarios/verificar-autorizacion', data),
  getAuditLogs: () => api.get('/usuarios/audit-logs'),

  // Medios de pago
  getMediosDePago: () => api.get('/medios_de_pago'),

  // Extras
  getExtras: () => api.get('/extras'),
  getExtrasActivos: () => api.get('/extras/activos'),

  // Reportes/Desgloses que sí existen en tu back
  getVentasHistoricasPorUsuario: () => api.get('/registros/ventas_historicas_por_usuario'),
  getVentasPorUsuarioMedioPago: (usuarioId) =>
    api.get('/registros/ventas_por_usuario_medio_pago', { params: { usuario_id: usuarioId } }),
  getDetallesVentaUsuario: (usuarioId) =>
    api.get('/registros/detalles_venta', { params: { usuario_id: usuarioId } }),
  getDesgloseRendicion: (usuarioId) =>
    api.get('/registros/desglose_rendicion', { params: { usuario_id: usuarioId } }),

  // Embarcaciones / histórico de movimientos
  getHistoricoMovimientos: () => api.get('/historico-movimientos'),
};
